import * as Styles from './information-column.styles'
import { InformationColumnProps } from './information-column.types'

export const InformationColumn = ({
  label,
  value,
  align,
}: InformationColumnProps) => {
  return (
    <Styles.Column direction="column" flex={1} alignItems={align}>
      <Styles.OneLineText color="grey_3" size="small">
        {label}
      </Styles.OneLineText>
      {typeof value === 'string' ? (
        <Styles.OneLineText fontWeight={500}>{value}</Styles.OneLineText>
      ) : (
        value
      )}
    </Styles.Column>
  )
}
